import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette }) => ({
  activeText: {
    color: '#fff'
  },
  inactiveText: {
    color: '#999'
  },
  divider: {
    width: 50,
    height: 2,
    color: palette.grey.shade[20]
  }
}))
